<template>
	<v-card class="settings-page pa-7 pb-1 mt-8 pb-8" style="border-radius: 10px; max-width: 600px;" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null" class='mt-5'>
			<v-skeleton-loader
				style="max-width: 600px;"
				v-bind="attrs"
				type="card"
				v-if="isLoading"
			>
			</v-skeleton-loader>

			<ButtonBack />

			<UploadList
				v-if='!isLoading && uploads.length > 0'
				:resourcesItems="uploads"
			/>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import UploadList from '@/components/Resource/UploadList.vue'
import ButtonBack from '@/components/ButtonBack.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'

export default {
	name: 'SessionFilesPage',
	mixins: [Block],
	components: {
		UploadList,
		ButtonBack,
		PageBlocked
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'listMeta']),
		...mapGetters('event', ['event', 'isLoading', 'session' ]),

		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},
		uploads() {
			if (!this.session) {
				return [];
			}

			return this.session.uploads;
		},
		resourcesItems() {
			return this.resourcesList || [];
		},
		pageCount() {
			if (!this.listMeta) {
				return 0;
			}

			return +this.listMeta.pageCount
		}
	},
	methods: {
		...mapActions('resources', ['getResources']),
		...mapActions('event', ['getEvent', 'getSession']),

		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		onPageChange(page) {
			const params = {
				search: this.filters.search,
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getResources(queryString)
		},
		formatFilters(filters) {
			const { search, page } = filters

			let queryString = `page=${page}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},
		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				search: e.target.value,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getResources(queryString)
			}, 500)
		},
	},
	data() {
		return {
			searchIcon,
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			filters: {
				page: 1,
				search: '',
			},
			pageBlockedName: 'events'
		}
	},
	created() {
		if (
			this.$route.params.eventId !== undefined &&
			this.$route.params.sessionId !== undefined &&
			(!this.isBlocked || this.isBlocked === null)
		) {
			this.getEvent(this.$route.params.eventId)
			this.getSession(this.$route.params.sessionId)
		}
	},
}
</script>

<style lang="scss">
.settings-page {
	&.v-tabs {
		font-style: normal;
		font-weight: bold !important;
		font-size: 20px;
		line-height: 67px;
		text-transform: capitalize;
		justify-content: space-between;
		letter-spacing: 0.1px !important;
	}

	&__title {
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}

	&__tabs {
		.v-tab {
			justify-content: space-between;
			font-style: normal;
			font-weight: 900;
			font-size: 20px;
			line-height: 67px;
			text-transform: capitalize;
			color: #cbcbcb !important;

			&--active {
				color: #4d536e !important;
			}
		}
	}

	@media screen and (max-width: 960px) {
		.settings-page__title {
			font-size: 25px !important;
		}
		.v-tabs-bar {
			display: contents;
		}
		.v-tab {
			font-size: 18px !important;
		}
	}
	@media screen and (max-width: 600px) {
		.v-card__text {
			padding: 0;
		}
		.v-tab {
			padding: 0 3px;
		}
	}
}
</style>
